module.exports = __webpack_public_path__ + "static/media/ru.2c9a8f15.png";